import * as constants from './constants';

export const getVersion = () => ({ type: constants.GET_VERSION });
export const getVersionSuccess = (payload) => ({
  type: constants.GET_VERSION_SUCCESS,
  payload,
});
export const getVersionError = (payload) => ({
  type: constants.GET_VERSION_ERROR,
  payload,
});

export const resetVersion = () => ({ type: constants.RESET_VERSION });
